export default __webpack_public_path__ + "static/media/no_content_test.475d3cdb.png";